import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Nav from '../nav';
import Footer from '../footer';
import Top from '../top';

function PreviewDemo() {
  const baseURL = process.env.REACT_APP_API_BASE_URL; // Ensure your `.env` file has the correct value
  const { pid, did } = useParams(); // Destructure pid and did from useParams
  const [product, setProduct] = useState({
    pname: '',
    image: '',
    min_qty: '',
  });
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [error2, setError2] = useState('');
  const maxFileSize = 15 * 1024 * 1024; // 15 MB in bytes
  
  const [quantity, setQuantity] = useState(0);
  const [rate, setRate] = useState(200);
  const [total, setTotal] = useState(0);
  const [selectedPaperSize, setSelectedPaperSize] = useState('');
  const [selectedPaperType, setSelectedPaperType] = useState('');
  const [selectedPrintingSide, setSelectedPrintingSide] = useState('');
  const [selectedLamination, setSelectedLamination] = useState('');
  const [selectedCorners, setSelectedCorners] = useState('');
  const [selectedCover, setSelectedCover] = useState('');
  const [selectedPagelayout, setSelectedPagelayout] = useState('');
  const [selectedStickersize, setSelectedStickersize] = useState('');
  const [selectedInnerPaper, setSelectedInnerPaper] = useState('');
  const [selectedPages, setSelectedPages] = useState('');
  

  // State to store price mappings fetched from API
  const [paperSizePrices, setPaperSizePrices] = useState({});
  const [paperTypePrices, setPaperTypePrices] = useState({});
  const [printingSidePrices, setPrintingSidePrices] = useState({});
  const [laminationPrices, setLaminationPrices] = useState({});
  const [cornerPrices, setCornerPrices] = useState({});
  const [coverPrices, setCoverPrices] = useState({});
  const [pagelayoutPrices, setPagelayoutPrices] = useState({});
  const [stickersizePrices, setStickersizePrices] = useState({});
  const [innerPaperPrices, setInnerPaperPrices] = useState({});
  const [pagesPrices, setPagesPrices] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
      name: '',
      email: '',
      phone: '',
      remark: ''
  });

  
  
  const [totalPrice, setTotalPrice] = useState(0);
    // State to store the current image being displayed
    const [currentImage, setCurrentImage] = useState(product.image);


    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
  };

  const handleSubmitModal = (e) => {
      e.preventDefault();
      console.log("Form Data Submitted: ", formData);
      setShowModal(false); // Close modal after submit
  };

    // Function to handle clicking on a smaller image
    const handleImageClick = (image) => {
      setCurrentImage(image);
    };

  useEffect(() => {
   
    const url = did ? `${baseURL}/demo-preview-design/${did}` : `${baseURL}/demo-preview-product/${pid}`;
    // Fetching product data
    axios
      .get(url)
      .then((response) => {
        if (response.data.product && response.data.product.length > 0) {
          const productData = response.data.product[0];
          setProduct({
            pname: productData.pname,
            image: productData.image,
            min_qty: productData.min_qty,
          });
          setCurrentImage(productData.image);
          setTotal(productData.price)

          if (productData.min_qty) {
            setQuantity(productData.min_qty);
          }

          // Fetch price mappings from the product data or another endpoint
          const paperSize = JSON.parse(productData.size || '{}');
          const paperType = JSON.parse(productData.type || '{}');
          const printingSide = JSON.parse(productData.side || '{}');
          const lamination = JSON.parse(productData.lamination || '{}');
          const corner = JSON.parse(productData.corner || '{}');
          const cover =JSON.parse(productData.cover || '{}');
          const pagelayout =JSON.parse(productData.page_layout || '{}');
          const stickersize =JSON.parse(productData.sticker_size || '{}');
          const innerpage = (JSON.parse(productData.inner_paper || '{}'));
         const pages = (JSON.parse(productData.pages || '{}'));

         

          // Setting state for price mappings
          setPaperSizePrices(paperSize);
          setPaperTypePrices(paperType);
          setPrintingSidePrices(printingSide);
          setLaminationPrices(lamination);
          setCornerPrices(corner);
          setCoverPrices(cover);
          setPagelayoutPrices(pagelayout);
        setStickersizePrices(stickersize);
        setInnerPaperPrices(innerpage);
        setPagesPrices(pages);

        
        } else {
          console.error('Product not found');
        }
      })
      .catch((error) => {
        console.error('Error fetching product details:', error);
      });
  }, [pid, baseURL]);

  const calculateTotal = (
    quantity,
    paperSize,
    paperType,
    printingSide,
    lamination,
    corner,
    cover,
    pagelayout,
    stickersize,
    innerpage,
    pages
  ) => {
    // Get the prices for the selected options
    const sizePrice = paperSizePrices[paperSize] || 0;
    const paperPrice = paperTypePrices[paperType] || 0;
    const printingPrice = printingSidePrices[printingSide] || 0;
    const laminationPrice = laminationPrices[lamination] || 0;
    const cornerPrice = cornerPrices[corner] || 0;
    const coverPrice = coverPrices[cover] || 0;
    const pagelayoutPrice = pagelayoutPrices[pagelayout] || 0;
    const stickersizePrice = stickersizePrices[stickersize] || 0;
    const innerPaperPrice = innerPaperPrices[innerpage] || 0;
    const pagesPrice = pagesPrices[pages] || 0;
  
    // Sum up the individual prices
    const totalOptionsPrice =
      sizePrice +
      paperPrice +
      printingPrice +
      laminationPrice +
      cornerPrice +
      coverPrice +
      pagelayoutPrice +
      stickersizePrice +
      innerPaperPrice +
      pagesPrice;
  
    // Multiply by quantity to get the total price
    const calculatedTotal = totalOptionsPrice * quantity;
  
    // Update the total price state
    setTotal(calculatedTotal);
  };

  const handleQuantityChange = (event) => {
    const value = parseInt(event.target.value || 0, 10);
    setQuantity(value);
    calculateTotal(
      value,
      selectedPaperSize,
      selectedPaperType,
      selectedPrintingSide,
      selectedLamination,
      selectedCorners,
      selectedCover,
      selectedPagelayout,
      selectedStickersize,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handlePaperSizeChange = (event) => {
    const value = event.target.value;
    setSelectedPaperSize(value);  
    calculateTotal(
      quantity,
      value,
      selectedPaperType,
      selectedPrintingSide,
      selectedLamination,
      selectedCorners,
      selectedCover,
      selectedPagelayout,
      selectedStickersize,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handlePaperTypeChange = (event) => {
    const value = event.target.value;
    setSelectedPaperType(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      value,
      selectedPrintingSide,
      selectedLamination,
      selectedCorners,
      selectedCover,
      selectedPagelayout,
      selectedStickersize,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handlePrintingSideChange = (event) => {
    const value = event.target.value;
    setSelectedPrintingSide(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      selectedPaperType,
      value,
      selectedLamination,
      selectedCorners,
      selectedCover,
      selectedPagelayout,
      selectedStickersize,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handleLaminationChange = (event) => {
    const value = event.target.value;
    setSelectedLamination(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      selectedPaperType,
      selectedPrintingSide,
      value,
      selectedCorners,
      selectedCover,
      selectedPagelayout,
      selectedStickersize,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handleCornersChange = (event) => {
    const value = event.target.value;
    setSelectedCorners(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      selectedPaperType,
      selectedPrintingSide,
      selectedLamination,
      value,
      selectedCover,
      selectedPagelayout,
      selectedStickersize,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handleCoverChange = (event) => {
    const value = event.target.value;
    setSelectedCover(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      selectedPaperType,
      selectedPrintingSide,
      selectedLamination,
      selectedCorners,
      value,
      selectedPagelayout,
      selectedStickersize,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handlePagelayoutChange = (event) => {
    const value = event.target.value;
    setSelectedPagelayout(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      selectedPaperType,
      selectedPrintingSide,
      selectedLamination,
      selectedCorners,
      selectedCover,
      value,
      selectedStickersize,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handleStickersizeChange = (event) => {
    const value = event.target.value;
    setSelectedStickersize(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      selectedPaperType,
      selectedPrintingSide,
      selectedLamination,
      selectedCorners,
      selectedCover,
      selectedPagelayout,
      value,
      selectedInnerPaper,
      selectedPages
    );
  };
  
  const handleInnerpaperChange = (event) => {
    const value = event.target.value;
    setSelectedInnerPaper(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      selectedPaperType,
      selectedPrintingSide,
      selectedLamination,
      selectedCorners,
      selectedCover,
      selectedPagelayout,
      selectedStickersize,
      value,
      selectedPages
    );
  };
  
  const handlepageChange = (event) => {
    const value = event.target.value;
    setSelectedPages(value);
    calculateTotal(
      quantity,
      selectedPaperSize,
      selectedPaperType,
      selectedPrintingSide,
      selectedLamination,
      selectedCorners,
      selectedCover,
      selectedPagelayout,
      selectedStickersize,
      selectedInnerPaper,
      value
    );
  };
  
  

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith('image/')) {
        setError('Please upload an image file.');
        setFile(null);
      } else if (selectedFile.size > maxFileSize) {
        setError('File size exceeds the 15 MB limit.');
        setFile(null);
      } else {
        setError('');
        setFile(selectedFile);
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  
    // Check for missing selections or file upload
    if (
      !selectedPaperSize ||
      !selectedPaperType ||
      !selectedPrintingSide ||
      !selectedLamination ||
      !selectedCorners ||
      !file
    ) {
      setError2('Please fill all fields and upload a file.');
      return;
    }
  
    // Prepare the form data for submission
    const formData = new FormData();
    formData.append('pid', pid);
    formData.append('quantity', quantity);
    formData.append('paperSize', selectedPaperSize);
    formData.append('paperType', selectedPaperType);
    formData.append('printingSide', selectedPrintingSide);
    formData.append('lamination', selectedLamination);
    formData.append('corner', selectedCorners);
    formData.append('file', file);
    formData.append('totalPrice', total);
  
    // Submit the order
    axios
      .post(`${baseURL}/submit-order`, formData)
      .then((response) => {
        if (response.data.success) {
          alert('Order submitted successfully!');
          // Optionally, you can reset form states or navigate to another page
          // resetForm();
        } else {
          setError('Failed to submit the order. Please try again.');
        }
      })
      .catch((error) => {
        console.error('Error submitting order:', error);
        setError2('An error occurred. Please try again later.');
      });
  };
  

  return (
    <>
      <Nav />
      <Top />
      <div className="container">
        <div className="row">
          <div style={{paddingLeft:'14px'}}>
            <ul className="demosubmenu">
              <li>Home / </li>
              <li>{product.pname || 'Loading...'}</li> {/* Product Name */}
            </ul>
          </div>
        </div>
        <div className="row preview-demo-row">

        <div className="col-sm-6 product-demo-div">
      {/* Main Image */}
      <img
        src={`${baseURL}/images/${currentImage}`}
        alt={product.pname}
        className="img-fluid"
        style={{ width: "100%", height: "64%" }}
      />

      {/* Smaller Images */}
      <div className="row" style={{ marginTop: "10px", paddingLeft: "13px", paddingRight: "5px" }}>
        {[product.image, product.image, product.image].map((img, index) => (
          <div key={index} className="col-sm-4" style={{ padding: "10px 10px 10px 0px", cursor:'pointer' }}>
            <img
              src={`${baseURL}/images/${img}`}
              alt={product.pname}
              className="img-fluid"
              style={{ width: "100%" }}
              onClick={() => handleImageClick(img)} // Update main image on click
            />
          </div>
        ))}
      </div>
    </div>

        
          <div className="col-sm-6 describe-demo-div">
          <form onSubmit={handleSubmit}>
            {/* Additional product details */}
            <p className='demo-productname'>{product.pname || 'Loading product name...'}</p> {/* Product Name */}
<hr />

<div className='row'>

{Object.keys(paperSizePrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text'>
      <label style={{ paddingTop: '10px' }}>Size</label>
    </div>
    <div
      className='col-sm-9 text-left lable-text'
      style={{ padding: '10px 105px 10px 19px' }}
    >
      <select
        className='form-control'
        value={selectedPaperSize}
        onChange={handlePaperSizeChange}
      >
        
        {Object.entries(paperSizePrices).map(([paperSize, price]) => (
          <option key={paperSize} value={paperSize}>
            {paperSize}
          </option>
        ))}
      </select>
    </div>
  </>
)}

{Object.keys(paperTypePrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text' style={{ padding: '13px' }}>
      <label>Paper Type</label>
    </div>
    <div
      className='col-sm-9 text-left lable-text'
      style={{ padding: '10px 105px 10px 19px' }}
    >
      <select
        className='form-control'
        value={selectedPaperType}
        onChange={handlePaperTypeChange}
      >
        <option value=''>Select Paper Type</option>
        {Object.entries(paperTypePrices).map(([paperType, price]) => (
          <option key={paperType} value={paperType}>
            {paperType}
          </option>
        ))}
      </select>
    </div>
  </>
)}


{Object.keys(pagesPrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text' style={{ padding: '13px' }}>
      <label>Pages</label>
    </div>
    <div
      className='col-sm-9 text-left lable-text'
      style={{ padding: '10px 105px 10px 19px' }}
    >
      <select
        className='form-control'
        value={selectedPages}
        onChange={handlepageChange}
      >
        <option value=''>Select Page</option>
        {Object.entries(pagesPrices).map(([pages, price]) => (
          <option key={pages} value={pages}>
            {pages}
          </option>
        ))}
      </select>
    </div>
  </>
)}

              {Object.keys(printingSidePrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text'>
      <label>Printing</label>
    </div>
    <div
      className='col-sm-9'
      style={{ padding: '2px 105px 10px 19px', display: 'flex' }}
    >
      {Object.entries(printingSidePrices).map(([printingSide, price]) => (
        <label key={printingSide} style={{ marginRight: '15px' }}>
          <input
            type="radio"
            name="printingSide"
            value={printingSide}
            onChange={handlePrintingSideChange}
          />
          &nbsp;
          {printingSide}
        </label>
      ))}
    </div>
  </>
)}

{Object.keys(coverPrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text'>
      <label>Cover</label>
    </div>
    <div className='col-sm-9' style={{ padding: '2px 105px 10px 19px' }}>
      {Object.entries(coverPrices).map(([cover, price]) => (
        <label key={cover} style={{ marginRight: '10px' }}>
          <input
            type="radio"
            name="lamination"
            value={cover}
            onChange={handleCoverChange}
          />
          &nbsp;
          {cover}
        </label>
      ))}
    </div>
  </>
)}


{Object.keys(coverPrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text'>
      <label>Page Layout</label>
    </div>
    <div className='col-sm-9' style={{ padding: '2px 105px 10px 19px' }}>
      {Object.entries(pagelayoutPrices).map(([pagelayout, price]) => (
        <label key={pagelayout} style={{ marginRight: '10px' }}>
          <input
            type="radio"
            name="pagelayout"
            value={pagelayout}
            onChange={handlePagelayoutChange}
          />
          &nbsp;
          {pagelayout}
        </label>
      ))}
    </div>
  </>
)}

{Object.keys(stickersizePrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text'>
      <label>Sticker Size</label>
    </div>
    <div className='col-sm-9' style={{ padding: '2px 105px 10px 19px' }}>
      {Object.entries(stickersizePrices).map(([stickersize, price]) => (
        <label key={stickersize} style={{ marginRight: '10px' }}>
          <input
            type="radio"
            name="stickersize"
            value={stickersize}
            onChange={handleStickersizeChange}
          />
          &nbsp;
          {stickersize}
        </label>
      ))}
    </div>
  </>
)}

{Object.keys(laminationPrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text'>
      <label>Lamination</label>
    </div>
    <div className='col-sm-9' style={{ padding: '2px 105px 10px 19px' }}>
      {Object.entries(laminationPrices).map(([lamination, price]) => (
        <label key={lamination} style={{ marginRight: '10px' }}>
          <input
            type="radio"
            name="lamination"
            value={lamination}
            onChange={handleLaminationChange}
          />
          &nbsp;
          {lamination}
        </label>
      ))}
    </div>
  </>
)}

{Object.keys(cornerPrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text'>
      <label>Corners</label>
    </div>
    <div className='col-sm-9' style={{ padding: '2px 105px 10px 19px' }}>
      {Object.entries(cornerPrices).map(([cornerPrice, price]) => (
        <label key={cornerPrice} style={{ marginRight: '20px' }}>
          <input
            type="radio"
            name="cornerPrice"
            value={cornerPrice}
            onChange={handleCornersChange}
          />
          &nbsp;
          {cornerPrice}
        </label>
      ))}
    </div>
  </>
)}

{Object.keys(innerPaperPrices).length > 0 && (
  <>
    <div className='col-sm-3 text-left lable-text'>
      <label>Inner Paper</label>
    </div>
    <div className='col-sm-9' style={{ padding: '2px 105px 10px 19px' }}>
      {Object.entries(innerPaperPrices).map(([innerPaperPrices, price]) => (
        <label key={innerPaperPrices} style={{ marginRight: '20px' }}>
          <input
            type="radio"
            name="innerPaperPrices"
            value={innerPaperPrices}
            onChange={handleInnerpaperChange}
          />
          &nbsp;
          {innerPaperPrices}
        </label>
      ))}
    </div>
  </>
)}


              <div className='col-sm-3 text-left lable-text'>
                <label>Quantity</label>
              </div>
              <div className='col-sm-7 text-left lable-text'>
                <input type='text' className='form-control' value={quantity} onChange={handleQuantityChange} min={1}/>
              </div>
              <br />


            </div>
            <div className="text-center price-demo-div">
              {quantity > 0 && total > 0 && <span className="price-demo">₹ {total} /-</span>}
            </div>
            <div className='col-sm-4'>
  {/* <button
                className='form-control btn btn-primary btn-sm'
                onClick={() => setShowModal(true)}
            >
                GET A QUOTE
            </button> */}
  </div>
<hr className='demo-hr'/>
<p className='preview-demo-p'>How would you like to design your cards?</p>
<div className='row' style={{ margin: -4 }}>

{/* <div className='col-sm-4' style={{ padding: 0 }}>
        <div className='preview-demo-icon-div'>
        <div className='preview-demo-icon3'>
        <img src={`${baseURL}/images/design.svg`} alt="Description" />
        </div>
        <p className='demo-icon-preview'>Use our templates</p>
        <ul className='demo-icon-list'>
            <li>Looking for inspiration</li>
            <li>simple customization</li>
        </ul>
        </div>
    </div> */}
    <div className='col-sm-4' style={{ padding: 0 }}>
      <div className='preview-demo-icon-div'>
        <div
          className='preview-demo-icon1'
          onClick={() => document.getElementById('fileInput').click()}
          style={{ cursor: 'pointer' }}
        >
          <img src={`${baseURL}/images/upload.svg`} alt="Description" />
        </div>
        <input
          type="file"
          id="fileInput"
          style={{ display: 'none' }}
          accept="image/*"
          onChange={handleFileChange}
        />
        <p className='demo-icon-preview'>Upload a full design</p>
        <ul className='demo-icon-list'>
          <li>Have a complete design</li>
          <li>Have your own designer</li>
        </ul>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {file && <p style={{ color: 'green', fontSize:'10px' }}>File uploaded: {file.name}</p>}
      </div>
    </div>
    {/* <div className='col-sm-4' style={{ padding: 0 }}>
        <div className='preview-demo-icon-div'>
        <div className='preview-demo-icon1'>
        <img src={`${baseURL}/images/upload.svg`} alt="Description" />
        </div>
        <p className='demo-icon-preview'>Upload a full design</p>
        <ul className='demo-icon-list'>
            <li>Have a complete design</li>
            <li>Have your own designer</li>
        </ul>
        </div>
    </div> */}
    <div className='col-sm-4' style={{ padding: 0 }}>

        <div className='preview-demo-icon-div'>
        <div className='preview-demo-icon2'>
        <img src={`${baseURL}/images/templates.svg`} alt="Description" />
        </div>
        <p className='demo-icon-preview'>Create own design</p>
        <ul className='demo-icon-list'>
            <li>Already have your logo</li>
            <li>Customize every detail</li>
        </ul>
        </div>
    </div>
    
</div>
{error2 && <p style={{ color: 'red', marginTop:'15px', fontSize: '15px', marginBottom:'-8px' }}>{error2}</p>}
<div className='row demo-button-row'>
  <div className='col-sm-4'>
  <input type='submit' name='submit' className='form-control btn btn-success btn-sm' value='Start Making' />
  </div>
  <div className='col-sm-4'>
  {/* here is button */}
  </div>

</div>
<div className='row'>
  <p style={{marginTop:'10px', color:'red'}}>for any other specification Size, paper type, qty, etc.
  </p>
  <button style={{width:'30%'}}
                className='form-control btn btn-primary btn-sm'
                onClick={() => setShowModal(true)}
            >
                GET A QUOTE
            </button>
</div>

</form>

          </div>
        
          
      

        </div>

        
      </div>
      {showModal && (
                <div className="modal" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Get A Quote</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone Number</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">File</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="remark" className="form-label">Remark</label>
                                        <textarea
                                            className="form-control"
                                            id="remark"
                                            name="remark"
                                            value={formData.remark}
                                            onChange={handleInputChange}
                                            rows="3"
                                            required
                                        ></textarea>
                                    </div>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
      <Footer />
    </>
  );
}

export default PreviewDemo;
